import LegalPage, { type LegalSection } from "@/components/public/LegalPage";

const SECTIONS: LegalSection[] = [
  { id: "preamble" },
  { id: "definitions" },
  { id: "scope" },
  { id: "subscription" },
  { id: "pricing" },
  { id: "payment" },
  { id: "trial" },
  { id: "rights" },
  { id: "withdrawal" },
  { id: "termination" },
  { id: "liability" },
  { id: "data" },
  { id: "ip" },
  { id: "law" },
];

export default function Cgv() {
  return (
    <LegalPage
      namespace="legal.cgv"
      sections={SECTIONS}
      lastUpdated="2026-05-13"
      contactEmail="contact@delapresse.fr"
    />
  );
}
